import RegPerson from "./RegPerson"

export default  RegPerson;
